import useSWR from 'swr';
import { TCartResponse } from '../data/schemas';
import { IGetCartParams } from '../data/schemas/request';
import { CartService } from '../service';

export function useGetCart(params: IGetCartParams | null) {
  const fetchKey = params ? ['cart-b2c', params.user_id] : null;

  const { data, error, isLoading, isValidating, mutate } = useSWR(
    fetchKey,
    () => {
      return CartService.getCart(params!);
    }
  );

  return {
    data: data as TCartResponse | undefined,
    isLoading,
    isValidating,
    error,
    refresh: mutate,
  };
}

export function useGetCartCount(params: IGetCartParams | null) {
  const fetchKey = params ? ['cart-b2c-count', params.user_id] : null;

  const { data, error, isLoading, isValidating, mutate } = useSWR(
    fetchKey,
    () => {
      return CartService.getCartCount(params!);
    }
  );

  return {
    data,
    isLoading,
    isValidating,
    error,
    refresh: mutate,
  };
}
